module.exports = __webpack_public_path__ + "static/media/淘宝2_04.87d00f64.jpg";